import { render, staticRenderFns } from "./ProjectCalendar.vue?vue&type=template&id=1c05306f&scoped=true&"
import script from "./ProjectCalendar.vue?vue&type=script&lang=js&"
export * from "./ProjectCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCalendar.vue?vue&type=style&index=0&id=1c05306f&scoped=true&lang=scss&"
import style1 from "./ProjectCalendar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c05306f",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCalendar,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c05306f')) {
      api.createRecord('1c05306f', component.options)
    } else {
      api.reload('1c05306f', component.options)
    }
    module.hot.accept("./ProjectCalendar.vue?vue&type=template&id=1c05306f&scoped=true&", function () {
      api.rerender('1c05306f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/management/ProjectCalendar.vue"
export default component.exports